export default __webpack_public_path__ + "locales/fr/UploadPanel.json?hash=2c69bbd80de474282a7ae719520a4e56";